import React, { useRef, useState } from "react";
import Image from "next/image";
import { Navigation, Pagination, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import { UserCircleIcon } from "@heroicons/react/solid";
import useWindowSize from "@/hooks/useWindowSize";
import VideoTestimonial from "./VideoTestimonial";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";

export default function Testimonials({ quotes, title, subtitle }) {
  const windowSize = useWindowSize();
  const beforeRef = useRef(null);
  const paginationRef = useRef(null);
  const afterRef = useRef(null);
  const [slideIndex, setIndex] = useState(0);
  return (
    <div className="relative flex sm:mb-8 sm:w-full sm:flex-col sm:px-2 sm:py-8 md:h-[532px] md:w-[744px] md:p-8 md:px-4 lg:mb-20 lg:h-[717px] lg:w-[1440px] lg:flex-row lg:justify-between lg:px-[116px] lg:py-40">
      <div className="flex flex-col justify-center sm:h-[130px] lg:mr-10 lg:h-full lg:w-fit">
        <div className="mb-8 leading-[42px] tracking-[-0.8px] sm:w-full sm:text-center sm:text-[36px] sm:font-light md:text-[40px] lg:w-[320px] lg:text-left lg:text-5xl">
          <span className="block">{title}</span>
          <span className="font-bold">{subtitle}</span>
        </div>
        <div className="flex items-center justify-center gap-5 align-middle lg:w-fit lg:flex-row lg:justify-start">
          <button
            ref={beforeRef}
            className=" absolute left-8 top-56 z-50 hidden border-2 border-black p-4 hover:bg-black hover:text-white lg:relative lg:left-auto lg:top-0 lg:flex"
          >
            <ArrowLeftIcon className="h-4 w-4" />
          </button>
          <button
            ref={afterRef}
            className="absolute right-8 top-56 z-[1] hidden border-2 border-black p-4 hover:bg-black hover:text-white lg:relative lg:right-auto lg:top-0 lg:flex"
          >
            <ArrowRightIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
      <div className="flex sm:h-[320px] lg:h-full lg:max-w-[900px]">
        <Swiper
          className="relative"
          loop={true}
          onActiveIndexChange={({ realIndex }) => {
            setIndex(realIndex);
          }}
          slidesPerView={1}
          modules={[Thumbs, Navigation, Pagination]}
          pagination={{
            clickable: true,
            type: "bullets",
            el: paginationRef.current,
            currentClass: "bg-neutral-900",

            bulletClass: "block w-6 h-1 bg-gray-200",
            bulletActiveClass: "bg-neutral-900",
          }}
          navigation={{
            nextEl: afterRef.current,
            prevEl: beforeRef.current,
            hiddenClass: "hidden",
            disabledClass: "text-neutral-50 border-neutral-50",
          }}
        >
          {quotes?.map((attributes) => {
            return (
              <>
                <SwiperSlide
                  key={attributes.id}
                  className="w-full sm:px-0 md:px-6 md:pl-10 lg:w-full"
                >
                  <div className=" flex justify-center sm:w-full md:gap-2 lg:w-full">
                    <div className="max-w-[120px]">
                      <Image
                        width={100}
                        height={100}
                        src="/next_assets/icons/quotation_marks.svg"
                        className="sm:w-[48px] md:w-[68px] lg:w-[88px]"
                        alt="quotation marks"
                      ></Image>
                    </div>
                    <div className="w-full sm:p-2 md:p-4">
                      <div className="w-full pb-4 font-light leading-[45px] tracking-[-0.72px] sm:text-xl md:text-2xl lg:text-4xl">
                        {attributes.description}
                      </div>
                      <div className="flex gap-4">
                        <UserCircleIcon className="w-25 h-25 flex items-center justify-center sm:h-10 sm:w-10 md:h-16 md:w-16" />
                        <div className="flex flex-col justify-center sm:text-sm md:text-base ">
                          <div>
                            @
                            <span className="font-bold">
                              {attributes.author}
                            </span>
                          </div>
                          <span className=" text-neutral-500">
                            {attributes.subtext}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                {attributes.video_url ? (
                  <SwiperSlide
                    key={attributes.video_url}
                    className="flex justify-center md:px-16 lg:px-32"
                  >
                    <VideoTestimonial urlVideo={attributes.video_url} />
                  </SwiperSlide>
                ) : null}
              </>
            );
          })}
          <div
            className="flex cursor-pointer gap-3 sm:absolute sm:top-[310px] sm:z-[1] sm:ml-[100px] sm:w-[auto!important] md:ml-[250px] lg:top-[390px] lg:ml-[300px]"
            ref={paginationRef}
          ></div>
        </Swiper>
      </div>
    </div>
  );
}
